// Format id by separating with equal spaces
export const formatUid = (id?: string | null, space = 3): string => !id ? "" : id.split("")
  .map((d, i) => (i % space == 0 ? " " + d : d))
  .join("")
  .trim();